<template>
  <div class="sp-template">
    <div class="h-title">{{title}}</div>
    <el-card class="box-card">
      <el-form 
        class="new-price__form" 
        :class="[isLook ? 'edit-price' : '']"
        :model="productPriceForm" 
        ref="productPriceForm" 
        size="small" 
        status-icon 
        :rules="rules"
        :label-width="formLabelWidth">
        <el-form-item label="价格适用范围"  v-if="!isLook && !isEdit">
          <span>
            <el-radio v-model="priceRange" label="customerType" @change.native="changePriceRange">客户类型</el-radio>
            <el-radio v-model="priceRange" label="customer" @change.native="changePriceRange">单个客户</el-radio>
          </span>
        </el-form-item>
        <el-form-item label="价格定义方式"  v-if="!isLook && !isEdit">
          <span>
            <el-radio v-model="priceType" label="discount" @change.native="changePriceType">折扣</el-radio>
            <el-radio v-model="priceType" label="custom" @change.native="changePriceType">自定义</el-radio>
          </span>
        </el-form-item>
        <el-form-item label="客户类型"  v-if="!isLook && !isEdit && priceRange == 'customerType'" class="is-required">
          <el-select 
            v-model.lazy="productPriceForm.customerType"
            placeholder="请输入搜索关键字"
            filterable
            clearable>
            <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户类型"  v-if="(isLook || isEdit) && $route.query.customerType && $route.query.customerType !== ''">
          <span >{{customerTypeMap[productPriceForm.customerType]}}</span>
        </el-form-item>
        <el-form-item label="客户"  v-if="!isLook && !isEdit && priceRange == 'customer'" class="is-required">
          <el-select 
            v-model.lazy="productPriceForm.orgOwner" 
            placeholder="请输入搜索关键字"
            filterable
            clearable>
            <el-option 
              v-for="(customer, index) in customerArr" 
              :key="index" 
              :label="customer.name" 
              :value="customer.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户"  v-if="(isLook || isEdit) && $route.query.customerName && $route.query.customerName !== ''">
          {{$route.query.customerName}}
        </el-form-item>
        <el-form-item label="渠道"  required prop="channelId" v-if="!isLook && !isEdit">
          <el-select 
            v-model.lazy="productPriceForm.channelId" 
            placeholder="请输入搜索关键字"
            clearable
            filterable
            @change = "getChannelById(productPriceForm.channelId)">
            <el-option 
              v-for="(channel, index) in channelArr" 
              :key="index" 
              :label="channel.name" 
              :value="channel.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道"  v-if="isEdit ||isLook">{{$route.query.channelName}}</el-form-item>
        <el-form-item v-if="!isLook && priceType == 'discount' && productPriceForm.discount != null" label="产品折扣"  class="is-required">
          <el-input v-model.lazy="productPriceForm.discount" placeholder="请输入产品折扣，如：75折，可直接填写 75" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="isLook && productPriceForm.discount != null" label="产品折扣" >
          <span>{{productPriceForm.discount}}</span>
        </el-form-item>
        <el-form-item v-if="!isLook && !isEdit && priceType == 'discount'" label="生效日期"  class="is-required">
            <el-form-item style="display: inline-block;">
              <el-date-picker v-model.lazy="productPriceForm.effectiveFrom" type="datetime" placeholder="请选择起始日期" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
            </el-form-item>
          <div style="display: inline-block; margin: 0 10px;">至</div>
            <el-form-item prop="effectiveTo" ref="effectiveToRef" style="display: inline-block;">
              <el-date-picker v-model.lazy="productPriceForm.effectiveTo" type="datetime" placeholder="请选择截至日期" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
            </el-form-item>
        </el-form-item>
        <el-form-item v-if="(isLook || isEdit) && productPriceForm.discount != null" label="生效日期" >
          <span v-if="isLook">{{productPriceForm.effectiveFrom}} &nbsp;&nbsp;至&nbsp;&nbsp;{{productPriceForm.effectiveTo}}</span>
          <span v-else>
            <el-col :span="5">
              <el-form-item>
                <el-date-picker v-model.lazy="productPriceForm.effectiveFrom" type="datetime" placeholder="请选择起始日期" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1" style="text-align: center;">&nbsp;至&nbsp;</el-col>
            <el-col :span="5">
              <el-form-item prop="effectiveTo">
                <el-date-picker v-model.lazy="productPriceForm.effectiveTo" type="datetime" placeholder="请选择截至日期" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </span>
        </el-form-item>
            		<div v-if="(isLook || priceType == 'custom') || (isEdit && productPriceForm.discount == null)">
                  	<el-form-item label="重量单位" v-if="!isLook" prop="newunitWeight"  class="is-required">
								<el-select name="unitWeight" v-model="productPriceForm.unitWeight" filterable clearable placeholder="请选择重量单位">
										<el-option v-for="(weightUnit, index) in weightUnits" :value="weightUnit.value" :key="index" :label="weightUnit.name"></el-option>
								</el-select>
							</el-form-item>
              <el-form-item label="重量单位"  v-if="isLook">{{$route.query.newunitWeight}}</el-form-item>
							<el-form-item label="整货最小重量" v-if="!isLook"  prop="newminTotalWeight"  class="is-required" >
								<el-input  auto-complete="off" v-model="productPriceForm.minTotalWeight" placeholder="整货最小重量" clearable  ></el-input>
							</el-form-item>
              <el-form-item label="整货最小重量"  v-if="isLook">{{$route.query.newminTotalWeight}}</el-form-item>
							<el-form-item label="整货最小体积" v-if="!isLook" class="is-required">
								<el-input  auto-complete="off" v-model="productPriceForm.minTotalVolume" placeholder="整货最小体积"  clearable>
									<template slot="append">cm³</template>
								</el-input>
							</el-form-item>
              <el-form-item label="整货最小体积"  v-if="isLook">{{$route.query.minTotalVolume}}</el-form-item>
							<el-form-item label="单件最大重量" v-if="!isLook" class="is-required" >
                <el-input  auto-complete="off" v-model="productPriceForm.maxWeightPerCarton" placeholder="单件最大重量" clearable ></el-input>
							</el-form-item>
              <el-form-item label="单件最大重量"  v-if="isLook">{{$route.query.maxWeightPerCarton}}</el-form-item>
							<el-form-item label="单件最小重量" v-if="!isLook"  class="is-required" >
								<el-input auto-complete="off" v-model="productPriceForm.minWeightPerCarton" placeholder="单件最小重量" clearable ></el-input>
							</el-form-item>
               <el-form-item label="单件最小重量"  v-if="isLook">{{$route.query.minWeightPerCarton}}</el-form-item>
							<el-form-item label="单件最小体积"  v-if="!isLook" class="is-required" >
								<el-input  auto-complete="off" v-model="productPriceForm.minVolumePerCarton" placeholder="单件最小体积"  clearable>
									<template slot="append">cm³</template>
								</el-input>
							</el-form-item>
              <el-form-item label="单件最小体积"  v-if="isLook">{{$route.query.minVolumePerCarton}}</el-form-item>
                </div>
        <!-- 计泡方式 -->
         <!-- v-if="(!isLook && priceType == 'custom') || (isEdit && productPriceForm.discount == null)" -->
        <el-form-item label="计泡方式"  prop="billedWeightCalculationMethod" 
        v-if="(!isLook && priceType == 'custom') || (isEdit && productPriceForm.discount == null)"
          class="is-required">
          <el-select v-model="productPriceForm.billedWeightCalculationMethod" clearable placeholder="请选择计泡方式">
            <el-option
              v-for="(item, index) in bubbleMethods"
              :key="index"
              :label="item.desc"
              :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip v-if="productPriceForm.billedWeightCalculationMethod == 'HALF_BUBBLE'" class="billWeightTips" effect="dark" 
            content="前提 体积重大于实重，公式 （实重 + 体积重）/ 2" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-tooltip v-if="productPriceForm.billedWeightCalculationMethod == 'ONE_THIRD_BUBBLE'" class="billWeightTips" effect="dark" 
            content="前提 体积重大于实重，公式（体积重 - 实重）/ 3 + 实重" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <!-- 查看计泡方式 -->
        <el-form-item label="计泡方式"  prop="billedWeightCalculationMethod" 
          v-if="isLook && productPriceForm.discount == null">
          <span>{{productPriceForm.billedWeightCalculationMethod | formatBilledWeightCalculationMethod}}</span>
        </el-form-item>
        <!-- 体积重计算比率 -->
        <el-form-item 
          label="体积重计算比率" 
          class="is-required"
          v-if="!isLook">
          <el-input v-model.lazy="productPriceForm.volumeWeightCalculationRadio" placeholder="体积重比率必须大于0" clearable />
        </el-form-item>
        <!-- 查看体积重计算比率 -->
        <el-form-item v-if="isLook && productPriceForm.discount == null" label="体积重计算比率" >
          <span>{{productPriceForm.volumeWeightCalculationRadio}}</span>
        </el-form-item>

        <el-form-item label="体积比率" class="is-required">
          <el-input v-model.lazy="productPriceForm.volumeActualWeightRatio" placeholder="体积重比率必须大于0" clearable />
        </el-form-item>

        <!-- 新增价格定义 -->
        <!-- v-show="productPriceForm.priceDefinitions && productPriceForm.priceDefinitions.length > 0" -->
        <!-- v-show="productPriceForm.priceDefinitions && productPriceForm.priceDefinitions.length > 0"  -->
        <el-form-item v-if=" !isEdit && priceType == 'custom'" label="价格定义"  class="is-required">
          <div v-if="!isLook && !isEdit"><i class="el-icon-circle-plus-outline"  @click="addPriceDefinition()"></i></div>
          <el-table border
          v-show="productPriceForm.priceDefinitions && productPriceForm.priceDefinitions.length > 0" 
          :data="productPriceForm.priceDefinitions" style="width: 600px;">
            <el-table-column label="日期">
              <template slot-scope="scope">
                <span>{{scope.row.effectiveFrom}}</span> 至 {{scope.row.effectiveTo}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <i class="el-icon-edit-outline" @click="editPriceDefinition(scope.row)"></i>
                <i class="el-icon-delete" v-if="scope.row.id==''" @click="deletePrice(scope.$index, productPriceForm.priceDefinitions)"></i>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="50">
              <template slot-scope="scope">
                <i :class='{checkColor : scope.row.id && scope.row.id !== "" && currentEffectivePriceId !== "" && scope.row.id == currentEffectivePriceId}' class="el-icon-circle-check"></i>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- 查看/编辑价格定义 -->
        <el-form-item v-if="(isLook || isEdit) && productPriceForm.discount == null" label="价格定义" >
          <el-table border style="width: 600px;" v-show="productPriceForm.priceDefinitions && productPriceForm.priceDefinitions.length  > 0" :data="productPriceForm.priceDefinitions">
            <el-table-column label="日期">
              <template slot-scope="scope">
                <span>{{scope.row.effectiveFrom}}</span> 至 {{scope.row.effectiveTo}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <i class="el-icon-edit-outline" @click="editPriceDefinition(scope.row)"></i>
                <i class="el-icon-delete" v-if="scope.row.id==''" @click="deletePrice(scope.$index, productPriceForm.priceDefinitions)"></i>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="50">
              <template slot-scope="scope">
                <i :class='{checkColor : scope.row.id && scope.row.id !== "" && currentEffectivePriceId !== "" && scope.row.id == currentEffectivePriceId}' class="el-icon-circle-check"></i>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="状态" >
          <span v-if="isLook">{{productPriceForm.status | formatStatus}}</span>
          <span v-else>
            <el-radio v-model="productPriceForm.status" label="1">启用</el-radio>
            <el-radio v-model="productPriceForm.status" label="0">停用</el-radio>
          </span>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="back">返 回</el-button>
      <el-button v-if="!isLook" type="primary" @click="submitProductPrice('productPriceForm')">确 定</el-button>
    </div>
    <definition 
      :aggregateId = "productPriceForm.channelId" 
      :weightUnit = "unitWeight"
      :minBillableWeight = "minTotalWeight"
      :dialogDefinitionVisible = "dialogDefinitionVisible" 
      :currentLayerIndex = "priceLayerIndex" 
      :BasicVariables = "basicVariable" 
      :initData = "priceDefinition" 
      @getDialogDefinitionVisible = "close"
      @callback = "getPriceDefinition"/>
  </div>
</template>

<script>
import {parseTime} from '../../util'
import definition from "../system/definition";
export default {
  data() {
    var checkEffectiveTo = (rule, value, callback) => {
      if (value && this.priceType == 'discount') {
        if(this.productPriceForm.effectiveFrom != ''){
          let startTime = new Date(this.productPriceForm.effectiveFrom).getTime();
          let endTime = new Date(value).getTime();
          if (startTime > endTime) {
            return callback(new Error('截至时间必须大于起始时间！'));
          } else{
            callback();
          }
        } else{
          return callback(new Error('截止日期不能为空！'))
        }
      } else{
        return callback(new Error('截止日期不能为空！'))
      }
    };
    return {
      weightUnits: [
        { name: "KG", value: "KG" },
        { name: "Pounds", value: "POUNDS" },
        { name: "Ounce", value: "OZ" }
			],//重量单位
      priceRange: "customerType",
      priceType: "discount",
      hiddenYesOrNo: false,
      unitWeight: "",
      minTotalWeight: "",
      dialogDefinitionVisible: false,
      priceLayerIndex: 0,
      basicVariable: [],
      bubbleMethods: [],
			priceDefinition: {},
			salesPriceDefineds: {},
      productPriceForm: {
        id: "",
        customerType: "",
        orgOwner: "",
        channelId: "",
        discount: "",
        billedWeightCalculationMethod: this.$route.query.billedWeightCalculationMethod,
        volumeWeightCalculationRadio: "6000",
        effectiveFrom: parseTime(new Date()),
        effectiveTo: "",
        status: "1",
        priceDefinitions: [],
        unitWeight:this.$route.query.newunitWeight,
        minTotalWeight:this.$route.query.newminTotalWeight,
        minTotalVolume:this.$route.query.minTotalVolume,
        maxWeightPerCarton:this.$route.query.maxWeightPerCarton,
        minWeightPerCarton:this.$route.query.minWeightPerCarton,
        minVolumePerCarton:this.$route.query.minVolumePerCarton,
        volumeActualWeightRatio: this.$route.query.volumeActualWeightRatio
      },
      newunitWeight:'',
      newminTotalWeight:'',
      minTotalVolume:'',
      maxWeightPerCarton:'',
      minWeightPerCarton:'',
      minVolumePerCarton:'',
      customerArr: [],
      channelArr: [],
      customerTypeMap: {},
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      formLabelWidth: "130px",
      formatChannelId: "",
      formatOrgOwner: "",
      currentEffectivePriceId: "",
      rules: {
        channelId: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        effectiveTo: [
          {validator: checkEffectiveTo, trigger: 'change'}
        ],
      }
    };
  },
  components: {
    definition
  },
  filters: {
    formatStatus (val) {
      return val == 1 ? '启用':'停用';
    },
    formatBilledWeightCalculationMethod (val) {
      switch (val) {
        case "ACTUALLY_WEIGHT":
          return "实重"
          break
        case "NOT_BUBBLE":
          return "不计泡"
          break
        case "HALF_BUBBLE":
          return "半泡"
          break
        case "ONE_THIRD_BUBBLE":
          return "1/3泡运"
          break
        case "VOLUME":
          return "体积(m³)"
          break
      }
    }
  },
  created() {
    // console.log(this.$route.query.billedWeightCalculationMethod)
    setTimeout(() => {
      this.getCustomer();
      this.getChannel();
      this.initBubbleMethod()
      this.getCustomerType()
      if(this.basicVariable.length == 0){
        this.initBasicVariable();
      }
      if(this.$route.query.id !== '' && this.$route.query.id !== undefined){
        let id = this.$route.query.id;
        this.initProductPriceForm(id);
      }
      if(this.$route.query.channelId !== '' && this.$route.query.channelId !== undefined){
        let channelId = this.$route.query.channelId;
        this.getChannelById(channelId);
        // this.findCurrentEffectivePriceDefinition (channelId, customerType,  orgOwner);
      }
      if(this.$route.query.orgOwner && this.$route.query.orgOwner !== '') {
        this.productPriceForm.orgOwner = this.$route.query.orgOwner
      }
      if(this.$route.query.customerType && this.$route.query.customerType !== '') {
        this.productPriceForm.customerType = this.$route.query.customerType
      }
      if(this.$route.query.channelId && this.$route.query.channelId !== '') {
        this.productPriceForm.channelId = this.$route.query.channelId
      }
    }, 500)
  },
  computed: {
    orgOwner (){
      return this.productPriceForm.orgOwner;
    },
    channelId (){
      return this.productPriceForm.channelId;
    },
    isLook() {
      let isLook =
        this.$route.query.look ? true : false;
      return isLook;
    },
    isEdit() {
      let isEdit =
        this.$route.query.edit ? true : false;
      return isEdit;
    },
    title() {
      if(this.isEdit) {
        return '编辑价格'
      } else if(this.isLook) {
        return '查看价格'
      } else if (!this.isEdit && !this.isLook) {
        return '新建价格'
      }
    }
  },
  methods: {
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取计泡方式枚举
		initBubbleMethod() {
			this.$request1({
        type: 'GET',
        url: '/system/channel/getBubbleMethod',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
				if(response.data && response.data.length > 0) {
          this.bubbleMethods = response.data
				} else{
					this.$notify.warning({
						title: '提示',
						message: '获取计泡方式失败！'
					})
				}
			})
			.catch(error => {
				console.log(error);
			});
		},
    clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
    changePriceRange() {
      // 客户和客户类型只能二选一
      if(!this.isEdit && this.priceRange == 'customerType'){
        this.productPriceForm.orgOwner = ''
      } else if(!this.isEdit && this.priceRange == 'customer') {
        this.productPriceForm.customerType = ''
      }
    },
    changePriceType() {
      if(!this.isEdit && this.priceType == 'discount') {
        this.productPriceForm.billedWeightCalculationMethod = ""
        this.productPriceForm.volumeWeightCalculationRadio = '6000'
        this.priceDefinition = {}
        this.productPriceForm.priceDefinitions = []
      } else if (!this.isEdit && this.priceType == 'custom') {
        this.productPriceForm.discount = ''
        this.productPriceForm.effectiveFrom = parseTime(new Date())
        this.productPriceForm.effectiveTo = ''
      }
    },
    // 通过渠道ID查重量单位和最小计费重
    getChannelById(channelId) {
      this.$request1({
        type: 'GET',
        url: '/system/channel/getChannel/' + channelId + '',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
        this.unitWeight = String(response.data.unitWeight);
        this.minTotalWeight = String(response.data.minTotalWeight);
        if(response.data.billedWeightCalculationMethod) {
          // this.productPriceForm.billedWeightCalculationMethod = response.data.billedWeightCalculationMethod
        }
			})
			.catch(error => {
				console.log(error);
			});
    },
    // 获取价格定义基本变量
		initBasicVariable() {
			this.$request1({
        type: 'GET',
        url: '/system/channel/getVariable',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
				this.basicVariable = response.data;
			})
			.catch(error => {
				console.log(error);
			});
		},
    // 查询当前有效价格ID
		findCurrentEffectivePriceDefinition (channelId, customerType, orgOwner){
			if(channelId && channelId != ""){
				this.$request1({
					type: 'GET',
					url: '/price/customerProductPrice/check/' + channelId + '/' + customerType + '/' + orgOwner + '',
					xhrFields: {
						withCredentials: true
					}
				})
				.then(response => {
          this.currentEffectivePriceId = response.data;
				})
				.catch(error => {
					console.log(error);
				});
			}
		},
    // 通过价格id获取价格信息
    initProductPriceForm (id) {
      if (id){
        this.$request1({
          method: 'GET',
          url: '/price/customerProductPrice/queryById/' + id + ''
        }).then(response => {
          if(response.data.success){
            let data = response.data.data;
            this.productPriceForm.id = data.id;
            this.productPriceForm.customerType = data.customerType;
            this.productPriceForm.orgOwner = data.orgOwner;
            if(this.customerArr && this.customerArr.length > 0){
              this.customerArr.forEach((c, index) => {
                if (data.orgOwner == c.id){
                  this.productPriceForm.customerName = c.name;
                }
              })
            }
            this.productPriceForm.channelId = data.channelId;
            if(this.channelArr && this.channelArr.length > 0){
              this.channelArr.forEach((c, index) => {
                if(data.channelId == c.id){
                  this.productPriceForm.channelName = c.name;
                }
              })
            }
            this.productPriceForm.discount = data.discount ? String(data.discount) : data.discount;
            // this.productPriceForm.billedWeightCalculationMethod = data.billedWeightCalculationMethod
            this.productPriceForm.volumeWeightCalculationRadio = data.volumeWeightCalculationRadio;
            this.productPriceForm.effectiveFrom = data.effectiveFrom;
            this.productPriceForm.effectiveTo = data.effectiveTo;
            this.productPriceForm.status = (data.enable == true ? '1' : '0');
            this.productPriceForm.priceDefinitions.push(data.priceDefinitions);
          } else{
            this.$message.error(response.data.message)
          }
        }).catch(error => {
          this.$message(error)
        })
          
      }
    },
    // 获取客户名
    getCustomer() {
      this.$request1({
        method: 'GET',
				url: '/customerAll'
      }).then(response => {
        if (response.data.success) {
          this.customerArr = response.data.data;
        } else{
          this.$message.error(response.data.message)
        }
       
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 获取渠道名
    getChannel() {
      this.$request1({
        method: 'GET',
				url: '/system/channel/all'
      }).then(response => {
        this.channelArr = response.data;
      }).catch(error => {
        this.$message.error.log(error)
      })
    },
    // 提交价格定义
    submitProductPrice(formName) {
      // console.log(typeof(this.productPriceForm.unitWeight))
      this.$refs[formName].validate((valid) => {
        if(valid){
          if(!this.isEdit && this.priceRange === 'customerType') {
            if(this.productPriceForm.customerType === '') {
              this.$notify.warning({
                title: '提示',
                message: '请选择客户类型'
              })
              return
            }
          }else if(!this.isEdit && this.priceRange === 'customer') {
            if(this.productPriceForm.orgOwner === '') {
              this.$notify.warning({
                title: '提示',
                message: '请选择客户'
              })
              return
            }
          }
          if(!this.isEdit && this.priceType === 'discount'){ // 价格定义方式为折扣
            // 校验 折扣
            var pattern = /^[0-9]+.?[0-9]*$/
            if(this.productPriceForm.discount === '') {
              this.$notify.warning({
                title: '提示',
                message: '请输入折扣'
              })
              return
            } else if(!pattern.test(this.productPriceForm.discount)) {
              this.$notify.warning({
                title: '提示',
                message: '请输入数字值，如：75 表示75折'
              })
              return
            } else if(Number(this.productPriceForm.discount) >= 100) {
              this.$notify.warning({
                title: '提示',
                message: '当前折扣大于或等于100，请输入合理的折扣'
              })
              return
            } else if(this.productPriceForm.discount.indexOf('.') !== -1 && this.productPriceForm.discount.split('.')[1].length >= 6) {
              this.$notify.warning({
                title: '提示',
                message: '当前折扣小数点后的部分过长，请重新输入'
              })
              return
            }
          }else if(!this.isEdit && this.priceType === 'custom') { // 自定义
            // 计泡方式
            if(this.productPriceForm.billedWeightCalculationMethod === '') {
              this.$notify.warning({
                title: '提示',
                message: '请选择计泡方式'
              })
              return
            }
            // 校验体积重计算比率
            if(this.productPriceForm.volumeWeightCalculationRadio === '') {
              this.$notify.warning({
                title: '提示',
                message: '请填写体积重计算比率，且必须大于0'
              })
              return
            } else if(this.productPriceForm.volumeWeightCalculationRadio <= 0) {
              this.$notify.warning({
                title: '提示',
                message: '体积重计算比率必须大于0'
              })
              return
            }
            if(JSON.stringify(this.priceDefinition) == '{}') {
              this.$notify.warning({
                title: '提示',
                message: '您当前选择的是自定义价格，请完成价格定义！'
              })
              return
            }
          }
          if(this.isEdit && this.productPriceForm.discount == null) {
            if(this.productPriceForm.billedWeightCalculationMethod === '') {
              this.$notify.warning({
                title: '提示',
                message: '请选择计泡方式'
              })
              return
            }
            if(this.productPriceForm.volumeWeightCalculationRadio === '' || this.productPriceForm.volumeWeightCalculationRadio === 0) {
              this.$notify.warning({
                title: '提示',
                message: '体积重计算比率必须大于0'
              })
              return
            }
          } else if(this.productPriceForm.unitWeight===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写重量单位'
              })
              return
          }
           else if(this.productPriceForm.minTotalVolume===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写整货最小体积'
              })
              return
          }
           else if(this.productPriceForm.minTotalWeight===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写整货最小重量'
              })
              return
          }
           else if(this.productPriceForm.maxWeightPerCarton===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写单件最大重量'
              })
              return
          }
           else if(this.productPriceForm.minWeightPerCarton===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写单件最小重量'
              })
              return
          }
           else if(this.productPriceForm.minVolumePerCarton===undefined) {
             this.$notify.warning({
                title: '提示',
                message: '必须填写单件最小体积'
              })
              return
          }
          this.productPriceForm.status = parseInt(this.productPriceForm.status);
          if(this.productPriceForm.customerType == ""){
            this.productPriceForm.customerType = null;
          }
          if(this.productPriceForm.orgOwner == ""){
            this.productPriceForm.orgOwner = null;
          }
          if(this.isEdit){ // 编辑
            if(this.productPriceForm.discount == null){
              this.productPriceForm.effectiveFrom = this.productPriceForm.priceDefinitions[0].effectiveFrom
              this.productPriceForm.effectiveTo = this.productPriceForm.priceDefinitions[0].effectiveTo

              this.productPriceForm.priceDefinitions.forEach((price, index) => {
                price['volumeWeightCalculationRadio'] = Number(this.productPriceForm.volumeWeightCalculationRadio)
                price['billedWeightCalculationMethod'] = this.productPriceForm.billedWeightCalculationMethod;
                price['unitWeight'] = this.productPriceForm.unitWeight;
                price['minTotalWeight'] = this.productPriceForm.minTotalWeight;
                price['minTotalVolume'] = this.productPriceForm.minTotalVolume;
                price['maxWeightPerCarton'] = this.productPriceForm.maxWeightPerCarton;
                price['minWeightPerCarton'] = this.productPriceForm.minWeightPerCarton;
                price['minVolumePerCarton'] = this.productPriceForm.minVolumePerCarton;
                price['volumeActualWeightRatio'] = this.productPriceForm.volumeActualWeightRatio;
              })
            }
          }else if(!this.isEdit && this.priceType === 'discount'){ // 新增，折扣
            this.productPriceForm.priceDefinitions = []
          } else if(!this.isEdit && this.priceType === 'custom'){ // 新增，自定义价格
            this.productPriceForm.discount = null;
            this.productPriceForm.priceDefinitions.forEach((price, index) => {
              price['volumeWeightCalculationRadio'] = Number(this.productPriceForm.volumeWeightCalculationRadio)
              price['billedWeightCalculationMethod'] = this.productPriceForm.billedWeightCalculationMethod;
              price['unitWeight'] = this.productPriceForm.unitWeight;
              price['minTotalWeight'] = this.productPriceForm.minTotalWeight;
              price['minTotalVolume'] = this.productPriceForm.minTotalVolume;
              price['maxWeightPerCarton'] = this.productPriceForm.maxWeightPerCarton;
              price['minWeightPerCarton'] = this.productPriceForm.minWeightPerCarton;
              price['minVolumePerCarton'] = this.productPriceForm.minVolumePerCarton;
              price['volumeActualWeightRatio'] = this.productPriceForm.volumeActualWeightRatio;
            })
          }
          this.$request1({
            method: 'POST',
            url: '/price/customerProductPrice/create',
            data: this.productPriceForm
          })
          .then(response => {
            if(response.data.success){
              this.$message.success('成功！')
              this.emptyForm();
              this.$router.push('/customer/productprice')
              this.$refs[formName].resetFields();	
            } else{
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error(error);
          });
        }else{
					return false;
        }
      })
    },
    emptyForm() {
      this.productPriceForm.id = "";
      this.productPriceForm.customerType = "";
      this.productPriceForm.orgOwner = "";
      this.productPriceForm.channelId = "";
      this.productPriceForm.discount = "";
      this.productPriceForm.billedWeightCalculationMethod = "";
      this.productPriceForm.volumeWeightCalculationRadio = "6000";
      this.productPriceForm.volumeActualWeightRatio = 0;
      this.productPriceForm.effectiveFrom = "";
      this.productPriceForm.effectiveTo = "";
      this.productPriceForm.status = "1";
      this.productPriceForm.priceDefinitions = [];
    },
    back() {
      this.$router.go(-1);
    },
    close(val) {
			this.dialogDefinitionVisible = val
    },
    getPriceDefinition (result) {
			this.dialogDefinitionVisible = false;
      result.updateOrAdd = "yes";
      if (this.priceDefinition.effectiveFrom === undefined) {
        this.priceDefinition = result;
        this.priceDefinition.id = "";
				this.productPriceForm.priceDefinitions.push(this.priceDefinition);
      } else {
        this.productPriceForm.priceDefinitions = this.productPriceForm.priceDefinitions.map(
          item => {
            if (item.id === result.id) {
              return result;
            } else {
              return item;
            }
          }
        );
      }
    },
    show () {
      if (this.hiddenYesOrNo === true) {
        this.hiddenYesOrNo = false;
      } else {
        this.hiddenYesOrNo = true;
      }
    },
    hiddenOrButton () {
      for (var i = 0; i < this.productPriceForm.priceDefinitions.length; i++) {
        if (
          this.productId != "" &&
          !this.dataCompare(this.productPriceForm.priceDefinitions[i].effectiveTo)
        ) {
          return true;
        }
      }
      return false;
		},
		addPriceDefinition() {
      if(this.productPriceForm.channelId === "") {
        this.$message.warning("请先选择渠道！")
        return;
      }
			this.priceDefinition = {}
			this.dialogDefinitionVisible = true
		},
		editPriceDefinition(val) {
      this.priceDefinition = val;
      let areas = this.priceDefinition.mainCharge.logisticPrice.areas
      if(areas && areas.length > 0) {
        areas.forEach((area, index) => {
          area.regionStr = area.regions.join();
        })
      }
      // this.priceDefinition.effectiveFrom = new Date(this.priceDefinition.effectiveFrom).getTime();
      // this.priceDefinition.effectiveTo = new Date(this.priceDefinition.effectiveTo).getTime();
			if (val.id !== "") {
				this.salesPriceDefineds[val.id] = [true]
			}
			this.dialogDefinitionVisible = true
    },
    deletePrice(index, rows){
			 this.$confirm("您确定要删除这条渠道信息吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
				rows.splice(index, 1);
			})
    },
  }
};
</script>

<style lang="scss" scoped>
.checkColor {
	color: #5CB85C;
}
</style>


// WEBPACK FOOTER //
// src/views/customer/newprice.vue